const createDatetimeMinMax = (datetime, daysBefore = 90, daysAfter = 90, year = false) => {
  const date = new Date(datetime)
  if (year) {
    const fullYear = date.getFullYear()
    return { minDatetime: new Date(fullYear, 0), maxDatetime: new Date(fullYear + 1, 0) }
  }
  const epochTime = date.getTime()
  const minDatetime = new Date(
    epochTime - daysBefore * 86400 * 1000
  ).toISOString()
  const maxDatetime = new Date(
    epochTime + 2 * (daysAfter * 86400 * 1000)
  ).toISOString()

  return { minDatetime, maxDatetime }
}

export default createDatetimeMinMax



// WEBPACK FOOTER //
// ./src/utility/createDatetimeMinMax.js